import { useQuery } from '@tanstack/react-query';

import { api } from 'constants/api';
import { ApiResponse } from 'types/utils/api-response';

export type AttributeValuesType = {
  value: string;
};

export type AttributeValuesResponseType = AttributeValuesType[];

export type AttributeValueType = {
  value: string;
  ui_presentation: string;
};

export type GetAttributeValuesResponseType = {
  count: number;
  results: AttributeValueType[];
};

export type GetAttributeValuesFormValues = {
  table_reference: string;
  type_keyword: string;
  search: string;
};

export const useGetAttributeValues = (params?: {
  table_reference: string;
  type_keyword: string;
  search: string;
}) => {
  const { table_reference, search, type_keyword } = params || {};
  return useQuery({
    queryKey: ['getAttributeValues', table_reference, type_keyword, search],
    enabled: Boolean(params),
    queryFn: async () => {
      const { data } = await api.get<
        ApiResponse<GetAttributeValuesResponseType>
      >(
        search
          ? `/attribute/values/list/${table_reference}/${type_keyword}?search=${search}`
          : `/attribute/values/list/${table_reference}/${type_keyword}`
      );

      return data.data;
    },
  });
};
